import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/getLocal';

export default function TheComp() {
    const { t } = useLang('theProduct.SectionH');
    const { pathname } = getLocal();
    const Link =
        'https://twitter.com/intent/tweet?text=%E3%81%A9%E3%82%93%E3%81%AA%E3%82%B7%E3%83%BC%E3%83%B3%E3%81%A7%E3%82%82%E6%B4%BB%E8%BA%8D%E3%81%99%E3%82%8B%E6%AC%A1%E4%B8%96%E4%BB%A3%E3%81%AE%E3%83%91%E3%83%AF%E3%83%BC%E3%82%92%E2%9A%A1%EF%B8%8F%0A9%E6%9C%881%E6%97%A5%E3%80%81EcoFlow%E3%82%88%E3%82%8A%E6%96%B0%E3%82%B7%E3%83%AA%E3%83%BC%E3%82%BA%E3%81%8C%E4%B8%80%E6%8C%99%E7%99%BB%E5%A0%B4%F0%9F%91%80%E2%9C%A8https://www.ecoflow.com/jp/next-level-power%0A%0A%23EcoFlow%20%23%E3%82%A8%E3%82%B3%E3%83%95%E3%83%AD%E3%83%BC%20%23%E3%83%9D%E3%83%BC%E3%82%BF%E3%83%96%E3%83%AB%E9%9B%BB%E6%BA%90%20%23DELTA3%20%23RIVER3%20%23RAPID';

    return (
        <div className={styles.TheComp} id="section-SectionH">
            <EfSpec />
            <EfSection
                pc="https://websiteoss.ecoflow.com/upload/image/1723106145655/pc_campaign.jpg"
                pad="https://websiteoss.ecoflow.com/upload/image/1723106145655/pc_campaign.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1723106145543/m_campaign.jpg"
                title={t('title')}
                desc={t('desc')}
                moreLink={Link}
                moreText={t('btn')}
                moreDataLayer={[
                    {
                        event: 'uaEvent',
                        event_name: 'activity_button',
                        page_name: pathname,
                        list_name: t('title'),
                        button_name: t('btn'),
                        function: 'Release commemoration campaign',
                    },
                ]}
            />
        </div>
    );
}
